type ComponentConfig = {
  type:
    | "title"
    | "input"
    | "doubleInput"
    | "suggestions"
    | "pills"
    | "desc"
    | "sixBox"
    | "box"
    | "scroll"
    | "card";
  quantity: number;
  props?: Record<string, any>;
};

type SkeletonType = {
  [sectionName: string]: ComponentConfig[];
};

export const skeletonType = (isMobile: boolean): SkeletonType => {
  return {
    // MOBILE_NUMBER_EMAIL: [
    //   { type: "title", quantity: 1 },
    //   {
    //     type: "pills",
    //     quantity: 2,
    //     props: { width: "w-[50%]", flexWrap: "flex-nowrap" },
    //   },
    //   { type: "input", quantity: 2 },
    //   { type: "desc", quantity: 1 },
    // ],
    MOBILE_OTP: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: "sixBox", quantity: 1 },
      { type: "desc", quantity: 1 },
    ],
    RESUME: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: "box", quantity: 1, props: { height: "h-60" } },
      { type: "box", quantity: 1, props: { height: "h-36" } },
    ],
    LINKEDIN: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "box", quantity: 1, props: { height: "h-36" } },
    ],
    FULL_NAME: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
    ],
    TOTAL_EXPERIENCE: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: isMobile ? "scroll" : "doubleInput", quantity: 1 },
    ],
    CURRENT_LOCATION: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "suggestions", quantity: 1 },
    ],
    NATIONALITY: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "suggestions", quantity: 1 },
    ],
    WORK_AUTH: [
      { type: "title", quantity: 1 },
      { type: "pills", quantity: 3 },
    ],
    CURRENT_DESIGNATION_CURRENT_COMPANY: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 2 },
    ],
    START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX: [
      { type: "desc", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: isMobile ? "scroll" : "doubleInput", quantity: 1 },
      { type: "desc", quantity: 1 },
    ],
    END_DATE: [
      { type: "title", quantity: 1 },
      { type: isMobile ? "scroll" : "doubleInput", quantity: 1 },
    ],
    SKILLS: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: "input", quantity: 1 },
    ],
    CURRENT_SALARY_HIDE_SALARY_CHECKBOX: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "desc", quantity: 1 },
    ],
    NOTICE_PERIOD: [
      { type: "title", quantity: 1 },
      { type: "pills", quantity: 8 },
    ],
    LAST_WORKING_DAY: [
      { type: "title", quantity: 1 },
      { type: isMobile ? "scroll" : "doubleInput", quantity: 1 },
    ],
    GENDER: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: "pills", quantity: 3 },
    ],
    TRIUMPH_FIELDS: [
      { type: "title", quantity: 1 },
      { type: "desc", quantity: 1 },
      { type: "pills", quantity: 2 },
      { type: "desc", quantity: 1 },
      { type: "pills", quantity: 2 },
    ],
    HIGHEST_QUALIFICATION: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "suggestions", quantity: 1 },
    ],
    QUALIFICATION_MEDIUM: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
    ],
    QUALIFICATION_BOARD: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
    ],
    YEAR_OF_GRADUATION: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
    ],
    SPECIALISATION: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "suggestions", quantity: 1 },
    ],
    UNIVERSITY: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "suggestions", quantity: 1 },
    ],
    EDUCATION_TYPE: [
      { type: "card", quantity: 1 },
      { type: "title", quantity: 1 },
      { type: "pills", quantity: 3 },
    ],
    PREFERRED_JOB_TITLE: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
    ],
    PREFERRED_LOCATION: [
      { type: "title", quantity: 1 },
      { type: "input", quantity: 1 },
      { type: "suggestions", quantity: 1 },
    ],
    WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX: [
      { type: "title", quantity: 1 },
      { type: "pills", quantity: 3 },
    ],
  };
};
